import axios from "axios";
import { API_ENDPOINT } from "../authApi/superAdminApi"; 


export const getAdmins = async () => {
  try {
    const token = localStorage.getItem("token"); // get token
    const response = await axios.get(API_ENDPOINT.GET_ALL_ADMINS, {
      headers: { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // <-- add token here
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAdmins:", error.response?.data || error.message);
    throw error;
  }
};

export const updateAdminPermissions = async (adminId, category, permissionType, value = true) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(
      `${API_ENDPOINT.UPDATE_ADMIN_PERMISSIONS}/${adminId}/permissions`,
      {
        adminPermissions: {
          [category]: { [permissionType]: value },
        },
      },
      {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, 
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error in updateAdminPermissions:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createAdmin = async (formData) => {
  try {
    const token = localStorage.getItem("token"); // SuperAdmin JWT
    const response = await axios.post(API_ENDPOINT.CREATE_ADMIN, formData, {
      headers: { 
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}` 
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in createAdmin:", error.response?.data || error.message);
    throw error;
  }
};

